<template>
  <div>
    <PaymentLinkModal 
      v-if="isOpen"
      :open="isOpen"
      :id="selectedId"
      :reload="reload"
      :modalClose="modalClose"
    />
    <div class="inline-block min-width-full overflow-hidden rounded-lg shadow bg-white p-4">
      <b-row class="mt-2 mb-2 align-items-center">
        <b-col md="2" sm="6">
          <b-form-input
            type="text"
            placeholder="링크를 입력하세요."
            v-model="search.linkKey"
            v-on:keyup.enter="getPagingList(currentPage)"
          />
        </b-col>
        <b-col md="2" sm="6">
          <b-form-checkbox
            id="checkbox-1"
            v-model="search.checkDeleted"
            name="checkbox-1"
            v-on:click="handleChangeCheckbox"
          >
            삭제상품 같이 보기
          </b-form-checkbox>
        </b-col>
        <b-col md="2" sm="12">
          <label for="startDt">검색 시작 날짜(생성일)</label>
          <b-form-input
            id="startDt"
            type="date"
            v-model="search.startDt"
          ></b-form-input>
        </b-col>
        <b-col md="2" sm="12">
          <label for="startDt">검색 종료 날짜(생성일)</label>
          <b-form-input
            id="startDt"
            type="date"
            v-model="search.endDt"
          ></b-form-input>
        </b-col>
        <b-col md="2" sm="12">
          <button
            v-on:click="handleSearch"
            class="mt-sm-2 btn btn-primary"
          >
            검색
          </button>
        </b-col>
      </b-row>
      <b-row class="text-right mb-4">
        <b-col>
          <button class="btn btn-success"  v-on:click="modalClose">
            링크 생성
          </button>
        </b-col>
      </b-row>
      <b-table :fields="fields" :items="paymentLinks">
        <template #cell(createdAt)="data">
          {{ getDate(data.item.createdAt)}}
        </template>
        <template #cell(info)="data">
          <button
            v-if="data.item.deletedAt == null"
            class="btn btn-primary"
            v-on:click="showDetailModal(data.item.id)">
            상품정보
          </button>
        </template>
        <template #cell(linkKey)="data">
          <p class="cursor" @click="copy(data.item.linkKey)">{{getURL(data.item.linkKey)}}</p>
        </template>
        <template #cell(button)="data">
          <button
            v-if="data.item.deletedAt == null"
            class="btn btn-outline-danger"
            v-on:click="setDelete(data.item)">
            삭제
          </button>
        </template>
      </b-table>
      <b-pagination
        align="center"
        v-model="currentPage"
        :total-rows="totalRows"
        :per-page="pageSize"
        @page-click="changePage"
      />
    </div>
  </div>
</template>
<script>
import api from "@/api/api"
import customDate from "@/util/custom-date"
import {copyText} from "vue3-clipboard"
import PaymentLinkModal from "@/components/modals/PaymentLinkModal.vue";

export default {
  components: {PaymentLinkModal},
  data() {
    return {
      paymentLinks: [],
      currentPage: 1,
      pageSize: 30,
      totalPage: 0,
      totalRows: 0,
      isOpen: false,
      selectedId: null,
      search: {
        linkKey: "",
        showDeleted: false,
        startDt: null,
        endDt: null
      },
      fields: [
        {
          label: '생성일',
          key: 'createdAt',
        },
        {
          label: '링크',
          key: 'linkKey',
        },
        {
          label: '링크정보',
          key: 'info',
        },
        {
          label: '',
          key: 'button',
          thStyle: { width: "20%" },
        }
      ],
    }
  },
  mounted() {
    // URL query params에서 상태 복원
    const query = this.$route.query
    if (query.page) {
      this.currentPage = parseInt(query.page)
    }
    if (query.linkKey) {
      this.search.linkKey = query.linkKey
    }
    if (query.checkDeleted === 'true') {
      this.search.showDeleted = true
    }
    if (query.startDt) {
      this.search.startDt = query.startDt
    }
    if (query.endDt) {
      this.search.endDt = query.endDt
    }
    
    this.getPagingList(this.currentPage)
  },
  methods: {
    getURL(linkKey) {
      return `${process.env.VUE_APP_WEB_URL}/pay/${linkKey}`
    },
    modalClose(){
      this.isOpen = !this.isOpen
    },
    handleChangeCheckbox() {
      this.search.showDeleted = !this.search.showDeleted
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    handleSearch() {
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    reload(){
      this.currentPage = 1
      this.updateQueryParams()
      this.getPagingList(1)
    },
    updateQueryParams() {
      const query = {
        page: this.currentPage.toString()
      }
      
      if (this.search.linkKey) {
        query.linkKey = this.search.linkKey
      }
      if (this.search.showDeleted) {
        query.checkDeleted = 'true'
      }
      if (this.search.startDt) {
        query.startDt = this.search.startDt
      }
      if (this.search.endDt) {
        query.endDt = this.search.endDt
      }
      
      this.$router.replace({ query })
    },
    getDate(date){
      return customDate.stringFormat(date)
    },
    copy(linkKey){
      const url = `${process.env.VUE_APP_WEB_URL}/pay/${linkKey}`
      copyText(url, linkKey, (err, event) => {
        this.$toast.show(err ? '복사 할 수 없습니다.' : '복사 완료',
          {
            position: "top-right",
            duration: 2000
          });
      })
    },
    showDetailModal(id) {
      this.selectedId = id
      this.modalClose()
    },
    changePage(event, page){
      this.currentPage = page
      this.updateQueryParams()
      this.getPagingList(this.currentPage)
    },
    setDelete(paymentLink){
      this.$store.dispatch('modal/openModal', {
        type: 'warning',
        title: '결제 링크 삭제',
        html: `${this.getURL(paymentLink.linkKey)} 링크를 비활성화합니다.\n 삭제하는 경우 이 링크는 사용할 수 없습니다.`,
        confirm: () => {
          api.paymentLink.delete({id: paymentLink.id} , () => {
            this.getPagingList(this.currentPage)
          },(err) => {
            console.log(err)
          })
        }
      });
    },
    getPagingList(page) {
      let params = {
        page: page,
        linkKey: this.search.linkKey,
        showDeleted: this.search.showDeleted,
      }
      
      if (this.search.startDt) {
        params.startDt =  `${this.search.startDt} 00:00:00`
      }

      if (this.search.endDt) {
        params.endDt =  `${this.search.endDt} 23:59:59`
      }
      
      api.paymentLink.list(params,(response) => {
        const {content, totalPages, totalElements} = response.data
        this.paymentLinks = content
        this.totalPage = totalPages
        this.totalRows = totalElements
        this.currentPage = page
      }, (err) => {
        console.log(err)
      })
    }
  }
}
</script>
